<template>
  <UiContainer class="my-4 lg:my-10">
    <hr class="border-fivefold" />
  </UiContainer>
</template>

<script setup lang="ts">
import UiContainer from './UiContainer.vue'
</script>
